import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import { MKT_POSTS_DESIGN as d } from '../MktPosts.design';

export default function PostsConnectHero({ onConnect }) {
    const { t } = useTranslation('marketing');

    return (
        <div className={d.connectHero.card}>
            <div className={d.connectHero.iconRow}>
                <div className={d.connectHero.iconBox}>
                    <Iconify icon="mdi:facebook" width={26} className="text-[#1877f2]" />
                </div>
                <div className={d.connectHero.iconBox}>
                    <Iconify icon="mdi:instagram" width={26} className="text-[#e1306c]" />
                </div>
            </div>

            <h2 className={d.connectHero.title}>{t('posts.connect.noAccountTitle')}</h2>
            <p className={d.connectHero.subtitle}>{t('posts.connect.noAccountSubtitle')}</p>

            <button type="button" className={d.connectHero.cta} onClick={onConnect}>
                <Iconify icon="eva:link-2-outline" width={16} />
                {t('posts.connect.noAccountCta')}
            </button>

            <div className={d.connectHero.steps}>
                {['step1', 'step2', 'step3'].map((passo, i) => (
                    <div key={passo} className={d.connectHero.step}>
                        <span className={d.connectHero.stepNumber}>{i + 1}</span>
                        <p className={d.connectHero.stepText}>{t(`posts.connect.${passo}`)}</p>
                    </div>
                ))}
            </div>

            <p className={d.connectHero.footnote}>
                <Iconify icon="eva:info-outline" width={14} />
                {t('posts.connect.footnote')}
            </p>
        </div>
    );
}
